function removeNonNumericCharacters(input: string) {
  return input.replace(/[^0-9]/g, '');
}

export const toPositiveNumber: React.FormEventHandler<HTMLInputElement> = (e) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value ? removeNonNumericCharacters(target.value) : '';
};
